import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { ExportAuditLogsRequest } from 'api';
import { AuditLogsService } from 'services';

const auditLogsService = new AuditLogsService();

const useAuditLogExport = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ payload, filename }: { payload: ExportAuditLogsRequest; filename: string }) => {
      // using this as it's easier to read the blob this way than using the generated swagger service
      const blob = await auditLogsService.exportLogs(payload);
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
    },
    onSuccess: () => {
      enqueueSnackbar('Audit logs exported successfully.', { variant: 'success' });
    },
    onError: (error: any) => {
      const message =
        error?.status === 404
          ? 'No audit logs were found for the selected criteria.'
          : 'Unable to export audit logs. Please try again later.';
      enqueueSnackbar(message, { variant: 'error' });
    },
  });
};

export default useAuditLogExport;
